import React from 'react'
import moment from 'moment'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import ReactApexChart from 'react-apexcharts'
import Spinner from './Spinner' // Ensure you have a Spinner component or use a library equivalent
import NodataYet from './NodataYet' // Ensure you have a NoDataYet component

interface WhereWhen {
  start: string
  end: string
}

interface chartData {
  data?: {
    data?: {
      total?: number
    }
  }
  isLoading?: boolean
}

interface seriesData {
  series: any[]
  options: any
}

interface LineChartCardProps {
  whereWhen?: WhereWhen
  chartData?: chartData
  seriesData: seriesData
  toolTipText: string
  title: string
}

const LineChartCard: React.FC<LineChartCardProps> = ({
  whereWhen,
  chartData,
  seriesData,
  toolTipText,
  title,
}) => {
  const {start, end} = whereWhen || {}
  const totalCount = chartData?.data?.data?.total || 0
  const isLoading = chartData?.isLoading

  return (
    <div className='card mt-5 w-355px h-300px chart_box'>
      <div className='row align-items-center'>
        <div className='top'>
          <div className='top_box'>
            <OverlayTrigger placement='top' overlay={<Tooltip>{toolTipText}</Tooltip>}>
              <h1 className='title'>{title}</h1>
            </OverlayTrigger>
            <p>
              {moment(start).format('MMM DD')} - {moment(end).format('MMM DD YY')}
            </p>
          </div>
          <div
            className='price'
            style={{
              color: '#12B886',
            }}
          >
            <p>{totalCount}</p>
          </div>
        </div>
      </div>

      {isLoading ? (
        <Spinner />
      ) : seriesData.series.length > 0 ? (
        <ReactApexChart
          options={seriesData.options}
          series={seriesData.series}
          height={210}
          type='line'
        />
      ) : (
        <NodataYet message={'No data yet'} />
      )}
    </div>
  )
}

export default LineChartCard
